import { VBaseInput } from '../VBaseInput';
import { VBaseSelect } from '../VBaseSelect';
import VSelectDisplayLabel from './VSelectDisplayLabel';
import type { VSelectProps } from './type';

const VSelect = <M extends boolean = false>(
  props: VSelectProps<M> &
    Omit<React.ComponentPropsWithRef<'input'>, 'size' | 'onChange'>,
) => {
  const {
    ref,
    className,
    comment,
    disabled,
    fluid,
    id,
    label,
    orientation,
    required,
    size,
    style,
    valid,

    ...rest
  } = props;

  const baseInputProps = {
    className,
    comment,
    disabled,
    fluid,
    id,
    label,
    orientation,
    required,
    size,
    style,
    valid,
  };

  return (
    <VBaseSelect {...rest} disabled={disabled} size={size}>
      <VBaseInput {...baseInputProps}>
        <VSelectDisplayLabel ref={ref} />
      </VBaseInput>
    </VBaseSelect>
  );
};

export default VSelect;
